import { useMemo, useState, useEffect } from 'react';

import { MacCommandIcon } from '../components/Icon';


export function useShortKeysNavigation() {
    const [isMac, setIsMac] = useState(false);

    useEffect(() => {
        // const mac =
        // typeof navigator !== 'undefined' &&
        // /mac/i.test(
        //   (navigator.userAgentData && navigator.userAgentData.platform) ||
        //     navigator.platform ||
        //     ''
        // ) &&
        // (navigator.maxTouchPoints || 0) <= 1; // відсікаємо iPadOS-13+ «MacIntel»
        const mac = /Mac|iPhone|iPad|iPod/.test(navigator.userAgentData?.platform || navigator.platform);

        setIsMac(mac);
    }, []);

    const map = useMemo(
        () => ({
            CTRL: isMac ? <MacCommandIcon /> : 'Ctrl',
            // CTRL: isMac ? 'Cmd' : 'Ctrl',
            ALT: isMac ? '⌥' : 'Alt',
            SHIFT: '⇧', //'Shift'
            ENTER: 'Enter',
        }),
        [isMac]
    );

    return { map, isMac };
};
